import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProfileAttributes } from '@loyalty/shared-common/profile-api-client';
import { colorPalette } from '@qualifio/ui-commons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { OfferRewardDialog } from './OfferRewardDialog';
import { useFeatures } from '../../../features/FeaturesContext';

const useStyles = makeStyles(() => ({
  offerRewardButton: {
    backgroundColor: colorPalette.orange.main,
    color: colorPalette.orange.contrastText,
    '&:hover': {
      backgroundColor: colorPalette.orange.dark,
      color: colorPalette.orange.contrastText,
    },
  },
}));

export interface OfferRewardButtonProps {
  profile: ProfileAttributes;
  onOffer?: () => Promise<void> | void;
}

export function OfferRewardButton({ profile, onOffer }: OfferRewardButtonProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { features } = useFeatures();
  const { enabled: offerRewardEnabled } = features[Feature.OFFER_REWARD];

  const handleClose = () => setDialogOpen(false);

  return (
    <>
      <Tooltip title={offerRewardEnabled ? '' : t('shared.action.permission.required')}>
        <div>
          <Button
            type="button"
            className={classes.offerRewardButton}
            startIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => setDialogOpen(true)}
            disabled={!offerRewardEnabled}
          >
            {t('profiles.details.rewards.offer-reward')}
          </Button>
        </div>
      </Tooltip>
      {dialogOpen && (
        <OfferRewardDialog profile={profile} onClose={handleClose} onOffer={onOffer} />
      )}
    </>
  );
}
